import {Box} from 'src/design/atoms/Box';
import {Center} from 'src/design/atoms/Center';
import React from 'react';
import {Link} from 'react-router-dom';

import {useAppDispatch, useAppSelector} from 'src/redux/hooks';
import {resetLogoUrl, setLogoUrl} from 'src/redux/slices/interfaceSlice';
import {useInstanceLogoUrl} from 'src/shared/hooks/useInstanceLogoUrl';

export const Logo: React.FC = () => {
  const {logoUrl} = useAppSelector(state => state.interface);
  const instanceLogoUrl = useInstanceLogoUrl();

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (instanceLogoUrl) {
      dispatch(setLogoUrl(instanceLogoUrl));
    } else {
      dispatch(resetLogoUrl());
    }
  }, [instanceLogoUrl, dispatch]);

  return (
    <Box w="100%">
      <Link to="/dashboard">
        <Center>
          <img src={logoUrl} height="30px" />
        </Center>
      </Link>
    </Box>
  );
};
